import {MultiSelectionBox} from 'notebook/tables/constants/TableSelectionConstants';
import {
  computeFillMaxJ,
  computeFillMinJ,
  computeIsFilledDown,
  computeIsFillDownBoxBottomEdge,
  computeIsFillDownBoxTopEdge,
  RowFillDown,
} from 'notebook/tables/store/logic/RowFillDownLogic';
import {TableModel} from 'notebook/tables/store/models/TableModel';
import {createDebuggableSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {
  createTableEditableStoreStructuredSelector,
  TableEditableStore,
} from 'notebook/tables/store/TableStore';

/**
 * Creates a selector that computes the per-row fill-down render state
 * ({@link RowFillDown}) for a single row from the {@link TableModel}.
 *
 * Single-input rows never participate in fill-down; treating their render box as
 * null collapses every value to its empty state (null / false), so the zeroing
 * lives here rather than branching on `isSingleInput` in the component.
 */
export function createRowFillDownSelector(
  tableSelector: (store: TableEditableStore) => TableModel,
  rowIndex: number,
  isSingleInput: boolean
): (store: TableEditableStore) => RowFillDown {
  const selectSelectionBox = (store: TableEditableStore): MultiSelectionBox | null =>
    isSingleInput ? null : tableSelector(store).fillDown.renderBox;

  return createTableEditableStoreStructuredSelector(
    {
      fillMinJ: (store) => computeFillMinJ(rowIndex, selectSelectionBox(store)),
      fillMaxJ: (store) => computeFillMaxJ(rowIndex, selectSelectionBox(store)),
      isFillDownBoxTopEdge: (store) => computeIsFillDownBoxTopEdge(rowIndex, selectSelectionBox(store)),
      isFillDownBoxBottomEdge: (store) => computeIsFillDownBoxBottomEdge(rowIndex, selectSelectionBox(store)),
      isFilledDown: (store) => computeIsFilledDown(rowIndex, selectSelectionBox(store)),
    },
    createDebuggableSelector.withTypes<TableEditableStore>()
  );
}
